// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinnerContainer":"LoadingSpinner_loadingSpinnerContainer__he8AH"};